import React from "react";
import styled from "styled-components";
import { Input } from "components/bootstrap";
import formValidation from "integrations/aws/utils/formValidation";
import Icon from "components/common/Icon";
const Error = styled.span`
  display: block;
  font-weight: normal;
  padding-left: 15px;
  font-size: 0.85em;
`;
const ErrorContainer = styled.span`
  display: flex;
  align-items: center;
`;
const Label = ({ label, error }) => {
  if (error) {
    return /* @__PURE__ */ React.createElement(ErrorContainer, null, label, /* @__PURE__ */ React.createElement(Error, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ", error));
  }
  return label;
};
const ValidatedInput = ({
  className = void 0,
  help = "",
  onChange = () => {
  },
  id,
  label,
  fieldData = {
    dirty: false,
    error: void 0,
    value: void 0
  },
  type = void 0,
  required = false,
  ...restProps
}) => {
  const { dirty, error, value } = fieldData;
  const checkValidity = (event) => {
    if (dirty) {
      const errorOutput = formValidation.checkInputValidity(event.target);
      onChange(event, { error: errorOutput });
    }
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      ...restProps,
      required,
      id,
      type,
      onChange,
      onBlur: checkValidity,
      className,
      bsStyle: error && dirty && "error" || void 0,
      defaultValue: type !== "select" && value || void 0,
      value: type === "select" && value || void 0,
      label: /* @__PURE__ */ React.createElement(Label, { label, error }),
      help
    }
  );
};
export default ValidatedInput;
